var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ProjectTree" },
    [
      _c("el-tree", {
        attrs: {
          lazy: "",
          "highlight-current": "",
          "default-expand-all": "",
          "expand-on-click-node": false,
          indent: 5,
          data: _vm.projectList,
          props: _vm.treeProps,
          load: _vm.loadTree
        },
        on: { "node-click": _vm.onTreeNodeClick },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var node = ref.node
              var data = ref.data
              return _c(
                "span",
                {
                  staticClass: "custom-tree-node",
                  staticStyle: { width: "85%" }
                },
                [
                  _c("span", { staticClass: "project-tree-item" }, [
                    _vm._v(_vm._s(node.label))
                  ]),
                  _vm._v(" "),
                  _c("ProjectTicketCount", {
                    staticStyle: { float: "right" },
                    attrs: { projectId: data.id }
                  })
                ],
                1
              )
            }
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "el-button",
        {
          staticStyle: { width: "100%", "margin-top": "20px" },
          on: { click: _vm.goProjectTable }
        },
        [_vm._v("管理项目")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-486e97c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-486e97c4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/ProjectTree.vue
// module id = 998
// module chunks = 75